<template>
  <v-container class="mt-4 px-5" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-toolbar flat>
            <v-icon left color="blue darken-2">mdi-brain</v-icon>
            <v-toolbar-title>Centro de Inteligencia Meta Ads</v-toolbar-title>
            <v-btn-toggle
              :value="escuela"
              mandatory
              rounded
              dense
              class="ml-4"
              color="blue darken-2"
              @change="cambiarEscuela"
            >
              <v-btn value="inbi" small>INBI</v-btn>
              <v-btn value="fast" small>FAST</v-btn>
            </v-btn-toggle>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text>
            <v-row align="center">
              <!-- TODO Fase 2 (histórico en BD): cambiar a rango fechaInicio/fechaFin y agregar
                   el switch "Comparar contra periodo anterior". Hoy el Analyzer genera un JSON por día. -->
              <v-col cols="12" sm="4" lg="3" xl="2">
                <v-text-field
                  v-model="fechaDatos"
                  label="Día de los datos"
                  type="date"
                  :max="fechaMaxima"
                  filled
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="auto">
                <v-btn color="primary" small tile @click="consultar">
                  <v-icon left small>mdi-refresh</v-icon>
                  Consultar
                </v-btn>
              </v-col>
              <v-col cols="12" sm class="text-sm-right" v-if="indicadores">
                <v-chip small class="mr-2" color="blue darken-2" dark>
                  Datos del {{ indicadores.fecha || '-' }}
                </v-chip>
                <v-chip small color="grey lighten-2">
                  <v-icon left small>mdi-clock-outline</v-icon>
                  Generado: {{ textoGeneracion }}
                </v-chip>
              </v-col>
            </v-row>

            <v-alert v-if="sinReporte" type="info" text dense class="mt-4 mb-0">
              No existe reporte del Analyzer con datos del {{ fechaDatos }} para {{ escuela.toUpperCase() }}.
              El reporte se genera cada mañana con los datos del día anterior; elige otra fecha.
            </v-alert>
            <v-alert v-else-if="reporte && !indicadores" type="warning" text dense class="mt-4 mb-0">
              El reporte de esa fecha se generó antes de la homologación y no trae los indicadores oficiales.
              Consúltalo en el Centro de Mando o elige una fecha posterior.
            </v-alert>
            <v-alert v-else-if="indicadores && indicadores.fecha && indicadores.fecha !== fechaDatos" type="warning" text dense class="mt-4 mb-0">
              El reporte encontrado trae datos del {{ indicadores.fecha }}, no del {{ fechaDatos }}.
            </v-alert>
          </v-card-text>

          <template v-if="indicadores">
            <v-tabs v-model="tab" color="blue darken-2" show-arrows>
              <v-tab><v-icon left small>mdi-view-dashboard</v-icon>Dirección</v-tab>
              <v-tab><v-icon left small>mdi-office-building</v-icon>Sucursales</v-tab>
              <v-tab><v-icon left small>mdi-bullhorn</v-icon>Anuncios</v-tab>
              <v-tab><v-icon left small>mdi-account-tie</v-icon>Vendedoras</v-tab>
              <v-tab><v-icon left small>mdi-book-open-variant</v-icon>Leyenda</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <!-- DIRECCIÓN -->
              <v-tab-item>
                <v-card-text>
                  <v-row dense>
                    <v-col v-for="t in tarjetasDireccion" :key="t.clave" cols="6" sm="4" md="3" lg="2">
                      <v-card outlined class="fill-height">
                        <v-card-text class="pa-3">
                          <div class="caption grey--text text--darken-1">{{ t.titulo }}</div>
                          <div class="text-h6 font-weight-bold">{{ t.valor }}</div>
                          <div v-if="t.nota" class="caption grey--text">{{ t.nota }}</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-tab-item>

              <!-- SUCURSALES -->
              <v-tab-item>
                <v-card-text>
                  <v-alert type="info" text dense>
                    <strong>Inversión:</strong> por plantel del nombre de la campaña (si la campaña no lo trae, el del conjunto).
                    <strong>Prospectos, completos, inscritos e ingresos:</strong> por sucursal de interés del prospecto.
                    Los costos por sucursal cruzan ambas reglas; úsalos como referencia.
                  </v-alert>
                  <v-data-table
                    :headers="headersSucursales"
                    :items="sucursales"
                    item-key="sucursal"
                    sort-by="gasto"
                    sort-desc
                    dense
                    class="elevation-0"
                    :items-per-page="-1"
                    hide-default-footer
                    mobile-breakpoint="0"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td v-for="h in headersSucursales" :key="h.value" :class="h.align === 'end' ? 'text-right' : ''">
                          {{ formatear(item[h.value], h.formato) }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-tab-item>

              <!-- ANUNCIOS -->
              <v-tab-item>
                <v-card-text>
                  <v-row dense align="center">
                    <v-col cols="12" sm="auto">
                      <v-btn-toggle v-model="vistaAnuncios" mandatory dense tile color="blue darken-2">
                        <v-btn value="anuncio" small>Por anuncio</v-btn>
                        <v-btn value="conjunto" small>Por conjunto</v-btn>
                      </v-btn-toggle>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-select v-model="filtroSucursal" :items="opcionesSucursal" label="Sucursal (gasto)" clearable filled dense hide-details></v-select>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-select v-model="filtroCampania" :items="opcionesCampania" label="Campaña" clearable filled dense hide-details></v-select>
                    </v-col>
                    <v-col cols="12" sm>
                      <v-text-field v-model="buscarAnuncio" label="Buscar" append-icon="mdi-magnify" clearable filled dense hide-details></v-text-field>
                    </v-col>
                  </v-row>
                  <div class="my-3">
                    <v-chip small color="red lighten-4" class="mr-2">
                      Gasto ≥ {{ formatoMoneda(umbralGastoSinCompletos) }} y 0 completos: {{ conteoAlertas.gasto }}
                    </v-chip>
                    <v-chip small color="orange lighten-4">
                      ≥ {{ umbralConversaciones }} conversaciones y menos de {{ umbralPctCompletos }} % completos: {{ conteoAlertas.conversaciones }}
                    </v-chip>
                  </div>
                  <v-data-table
                    :headers="headersAnunciosVista"
                    :items="filasAnuncios"
                    :item-key="vistaAnuncios === 'anuncio' ? 'ad_id' : 'clave'"
                    :search="buscarAnuncio"
                    sort-by="gasto"
                    sort-desc
                    dense
                    class="elevation-0"
                    :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }"
                    :items-per-page="25"
                    mobile-breakpoint="0"
                  >
                    <template v-slot:item="{ item }">
                      <tr :class="claseAlerta(item)">
                        <td v-for="h in headersAnunciosVista" :key="h.value" :class="h.align === 'end' ? 'text-right' : ''">
                          {{ formatear(item[h.value], h.formato) }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-tab-item>

              <!-- VENDEDORAS -->
              <v-tab-item>
                <v-card-text>
                  <v-alert type="info" text dense>
                    Contactos: prospectos atribuidos a Meta del día por vendedora asignada.
                    Inscripciones e ingresos: inscritos atribuidos del día por quien registró al alumno.
                    La conversión cruza ambos grupos del mismo día (no es la misma persona).
                  </v-alert>
                  <v-data-table
                    :headers="headersVendedoras"
                    :items="vendedoras"
                    item-key="clave"
                    sort-by="prospectos"
                    sort-desc
                    dense
                    class="elevation-0"
                    :items-per-page="-1"
                    hide-default-footer
                    mobile-breakpoint="0"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td v-for="h in headersVendedoras" :key="h.value" :class="h.align === 'end' ? 'text-right' : ''">
                          {{ formatear(item[h.value], h.formato) }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-tab-item>

              <!-- LEYENDA -->
              <v-tab-item>
                <v-card-text>
                  <v-simple-table dense>
                    <tbody>
                      <tr v-for="l in leyenda" :key="l.indicador">
                        <td class="font-weight-bold" style="width: 220px">{{ l.indicador }}</td>
                        <td>{{ l.definicion }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                  <div class="caption grey--text mt-2">Versión de indicadores: {{ indicadores.version || '-' }}</div>
                </v-card-text>
              </v-tab-item>
            </v-tabs-items>
          </template>
        </v-card>
      </v-col>
    </v-row>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>

<script>
  import Alerta from '@/components/alertas/Alerta.vue'
  import carga from '@/components/alertas/carga.vue'
  import validarErrores from '@/mixins/validarErrores'
  import {
    indicadoresHomologados,
    formatoMoneda,
    formatoEntero,
    formatoPct,
    formatoRoas,
    fechaMonterrey,
    sumarDias,
    fechaHoraMonterrey,
  } from '@/helpers/meta-ads-definiciones'

  const ESCUELAS = { inbi: 1, fast: 2 }
  const NOMBRE_RUTA = 'centroInteligenciaMeta'

  const COLUMNAS_METRICAS = [
    { text: 'Gasto', value: 'gasto', formato: 'moneda', align: 'end' },
    { text: 'Conversaciones', value: 'conversaciones_meta', formato: 'entero', align: 'end' },
    { text: 'Costo / conversación', value: 'costo_por_conversacion', formato: 'moneda', align: 'end' },
    { text: 'Nuevos', value: 'prospectos_nuevos', formato: 'entero', align: 'end' },
    { text: 'Rezagados', value: 'rezagados', formato: 'entero', align: 'end' },
    { text: 'Completos', value: 'registros_completos', formato: 'entero', align: 'end' },
    { text: 'Nuevos completos', value: 'nuevos_completos', formato: 'entero', align: 'end' },
    { text: 'Costo / nuevo completo', value: 'costo_por_nuevo_completo', formato: 'moneda', align: 'end' },
    { text: 'Inscritos', value: 'inscritos', formato: 'entero', align: 'end' },
    { text: 'Costo / inscripción', value: 'costo_por_inscrito', formato: 'moneda', align: 'end' },
    { text: 'Ingresos', value: 'ingresos_primer_pago', formato: 'moneda', align: 'end' },
  ]

  export default {
    components: { Alerta, carga },

    mixins: [validarErrores],

    data: () => ({
      fechaDatos: fechaMonterrey(-1),
      fechaMaxima: fechaMonterrey(-1),
      reporte: null,
      sinReporte: false,
      tab: 0,
      vistaAnuncios: 'anuncio',
      filtroSucursal: null,
      filtroCampania: null,
      buscarAnuncio: '',
      umbralConversaciones: 10,
      umbralPctCompletos: 20,

      headersSucursales: [
        { text: 'Sucursal', value: 'sucursal', formato: 'texto' },
        { text: 'Inversión', value: 'gasto', formato: 'moneda', align: 'end' },
        { text: 'Conversaciones', value: 'conversaciones_meta', formato: 'entero', align: 'end' },
        { text: 'Nuevos', value: 'prospectos_nuevos', formato: 'entero', align: 'end' },
        { text: 'Rezagados', value: 'rezagados', formato: 'entero', align: 'end' },
        { text: 'Completos', value: 'registros_completos', formato: 'entero', align: 'end' },
        { text: '% completos', value: 'pct_registros_completos', formato: 'pct', align: 'end' },
        { text: 'Costo / nuevo completo', value: 'costo_por_nuevo_completo', formato: 'moneda', align: 'end' },
        { text: 'Inscritos', value: 'inscritos', formato: 'entero', align: 'end' },
        { text: 'Costo / inscripción', value: 'costo_por_inscrito', formato: 'moneda', align: 'end' },
        { text: 'Ingresos', value: 'ingresos_primer_pago', formato: 'moneda', align: 'end' },
      ],

      headersVendedoras: [
        { text: 'Vendedora', value: 'vendedora', formato: 'texto' },
        { text: 'Contactos asignados', value: 'prospectos', formato: 'entero', align: 'end' },
        { text: 'Nuevos', value: 'prospectos_nuevos', formato: 'entero', align: 'end' },
        { text: 'Rezagados', value: 'rezagados', formato: 'entero', align: 'end' },
        { text: 'Completos recibidos', value: 'registros_completos', formato: 'entero', align: 'end' },
        { text: 'Inscripciones', value: 'inscritos', formato: 'entero', align: 'end' },
        { text: 'Conversión', value: 'tasa_conversion_pct', formato: 'pct', align: 'end' },
        { text: 'Ingresos', value: 'ingresos_primer_pago', formato: 'moneda', align: 'end' },
      ],

      leyenda: [
        { indicador: 'Inversión', definicion: 'Lo que Meta cobró ese día por los anuncios de la marca.' },
        { indicador: 'Conversaciones', definicion: 'Chats de WhatsApp que Meta reporta como iniciados. No son personas: una persona puede abrir varias.' },
        { indicador: 'Costo por conversación', definicion: 'Inversión entre conversaciones.' },
        { indicador: 'Prospecto nuevo', definicion: 'Persona (teléfono de 10 dígitos + marca) que escribe por primera vez desde un anuncio Meta ese día.' },
        { indicador: 'Rezagado', definicion: 'Persona que ya había escrito y vuelve después de 30 días o más sin escribir, desde un anuncio.' },
        { indicador: 'Registro completo', definicion: 'INBI: llenó la ficha de pre-registro o el bot le envió el contexto. FAST: quedó marcado como CONTACTO TWILIO COMPLETO.' },
        { indicador: 'Nuevo completo', definicion: 'Prospecto nuevo que además completó su registro ese día.' },
        { indicador: 'Costo por nuevo completo', definicion: 'Inversión entre nuevos completos.' },
        { indicador: 'Inscrito', definicion: 'Alumno con alta en grupo y primer pago ese día, que llegó por un anuncio Meta en los últimos 90 días.' },
        { indicador: 'Costo por inscripción', definicion: 'Inversión del día entre inscritos del día (el inscrito pudo llegar por un anuncio de días anteriores).' },
        { indicador: 'Ingresos atribuidos', definicion: 'Suma del primer pago de los inscritos atribuidos a Meta.' },
        { indicador: 'ROAS', definicion: 'Ingresos atribuidos entre inversión. 2x = por cada peso invertido entraron 2 en primeros pagos.' },
        { indicador: '% completos', definicion: 'Registros completos entre personas que escribieron (nuevos, rezagados y exalumnos que regresan).' },
        { indicador: 'Conversión de vendedora', definicion: 'Inscripciones de la vendedora entre sus contactos asignados del día. Son grupos distintos: es una referencia.' },
        { indicador: 'Sin dato / -', definicion: 'No hay base para calcularlo (por ejemplo, costo con 0 completos). Nunca se muestra como 0.' },
        { indicador: 'Fila roja', definicion: 'Anuncio con inversión igual o mayor al doble del costo por completo del día (o al gasto promedio si no hubo completos) y 0 completos.' },
        { indicador: 'Fila naranja', definicion: 'Anuncio con muchas conversaciones y menos del 20 % convertidas en registro completo.' },
      ],
    }),

    computed: {
      escuela () {
        const e = String(this.$route.params.escuela || '').toLowerCase()
        return ESCUELAS[e] ? e : 'inbi'
      },

      idEscuela () {
        return ESCUELAS[this.escuela]
      },

      indicadores () {
        return indicadoresHomologados(this.reporte)
      },

      global () {
        return (this.indicadores && this.indicadores.global) || {}
      },

      textoGeneracion () {
        const texto = fechaHoraMonterrey(this.indicadores && this.indicadores.generado_en)
        if (texto) return texto
        return this.reporte && this.reporte.date_report
          ? `${this.reporte.date_report} (hora no registrada)`
          : '-'
      },

      tarjetasDireccion () {
        const g = this.global
        const noAtribuibles = g.inscritos_no_atribuibles
        return [
          { clave: 'gasto', titulo: 'Inversión', valor: formatoMoneda(g.gasto) },
          { clave: 'conv', titulo: 'Conversaciones', valor: formatoEntero(g.conversaciones_meta) },
          { clave: 'cconv', titulo: 'Costo por conversación', valor: formatoMoneda(g.costo_por_conversacion) },
          { clave: 'nuevos', titulo: 'Prospectos nuevos', valor: formatoEntero(g.prospectos_nuevos) },
          { clave: 'rez', titulo: 'Rezagados', valor: formatoEntero(g.rezagados) },
          { clave: 'comp', titulo: 'Registros completos', valor: formatoEntero(g.registros_completos), nota: this.notaPct(g.pct_registros_completos) },
          { clave: 'ncomp', titulo: 'Nuevos completos', valor: formatoEntero(g.nuevos_completos) },
          { clave: 'cncomp', titulo: 'Costo por nuevo completo', valor: formatoMoneda(g.costo_por_nuevo_completo) },
          { clave: 'ins', titulo: 'Inscritos', valor: formatoEntero(g.inscritos), nota: noAtribuibles ? `+${noAtribuibles} sin anuncio Meta` : '' },
          { clave: 'cins', titulo: 'Costo por inscripción', valor: formatoMoneda(g.costo_por_inscrito) },
          { clave: 'ingr', titulo: 'Ingresos atribuidos', valor: formatoMoneda(g.ingresos_primer_pago) },
          { clave: 'roas', titulo: 'ROAS', valor: formatoRoas(g.roas) },
        ]
      },

      sucursales () {
        return (this.indicadores && this.indicadores.por_sucursal) || []
      },

      anuncios () {
        return ((this.indicadores && this.indicadores.por_anuncio) || []).map((a) => ({
          ...a,
          ad_name: a.ad_name || `(sin gasto en el día) ${a.ad_id}`,
        }))
      },

      conjuntos () {
        return ((this.indicadores && this.indicadores.por_conjunto) || []).map((c) => ({
          ...c,
          clave: `${c.campaign_name}||${c.adset_name}`,
        }))
      },

      headersAnunciosVista () {
        const base = [
          { text: 'Campaña', value: 'campaign_name', formato: 'texto' },
          { text: 'Conjunto', value: 'adset_name', formato: 'texto' },
        ]
        const detalle = this.vistaAnuncios === 'anuncio'
          ? { text: 'Anuncio', value: 'ad_name', formato: 'texto' }
          : { text: 'Anuncios', value: 'anuncios', formato: 'entero', align: 'end' }
        return base.concat([detalle], COLUMNAS_METRICAS)
      },

      filasAnuncios () {
        const filas = this.vistaAnuncios === 'anuncio' ? this.anuncios : this.conjuntos
        return filas.filter((f) =>
          (!this.filtroSucursal || f.sucursal_gasto === this.filtroSucursal) &&
          (!this.filtroCampania || f.campaign_name === this.filtroCampania)
        )
      },

      opcionesSucursal () {
        return [...new Set(this.anuncios.map((a) => a.sucursal_gasto).filter(Boolean))].sort()
      },

      opcionesCampania () {
        return [...new Set(this.anuncios.map((a) => a.campaign_name).filter(Boolean))].sort()
      },

      umbralGastoSinCompletos () {
        const costo = Number(this.global.costo_por_registro_completo)
        if (costo > 0) return Math.round(costo * 2 * 100) / 100
        const conGasto = this.anuncios.filter((a) => Number(a.gasto) > 0)
        if (!conGasto.length) return null
        const promedio = conGasto.reduce((s, a) => s + Number(a.gasto), 0) / conGasto.length
        return Math.round(promedio * 100) / 100
      },

      conteoAlertas () {
        const out = { gasto: 0, conversaciones: 0 }
        this.filasAnuncios.forEach((f) => {
          const c = this.claseAlerta(f)
          if (c === 'alerta-gasto') out.gasto++
          else if (c === 'alerta-conversaciones') out.conversaciones++
        })
        return out
      },

      vendedoras () {
        return ((this.indicadores && this.indicadores.por_vendedora) || []).map((v) => ({
          ...v,
          clave: v.id_usuario == null ? 'sin-asignar' : String(v.id_usuario),
        }))
      },
    },

    watch: {
      '$route.params.escuela' () {
        this.consultar()
      },
    },

    created () {
      if (this.$route.params.escuela !== this.escuela) {
        this.$router.replace({ name: NOMBRE_RUTA, params: { escuela: this.escuela } }).catch(() => {})
        return
      }
      this.consultar()
    },

    methods: {
      formatoMoneda,

      formatear (valor, formato) {
        if (formato === 'moneda') return formatoMoneda(valor)
        if (formato === 'entero') return formatoEntero(valor)
        if (formato === 'pct') return formatoPct(valor)
        return valor === null || valor === undefined || valor === '' ? '-' : valor
      },

      notaPct (pct) {
        const texto = formatoPct(pct)
        return pct === null || pct === undefined ? '' : `${texto} de quienes escribieron`
      },

      claseAlerta (fila) {
        const gasto = Number(fila.gasto) || 0
        const completos = Number(fila.registros_completos) || 0
        const conversaciones = Number(fila.conversaciones_meta) || 0
        const umbral = this.umbralGastoSinCompletos
        if (umbral !== null && gasto > 0 && gasto >= umbral && completos === 0) return 'alerta-gasto'
        if (conversaciones >= this.umbralConversaciones && (completos / conversaciones) * 100 < this.umbralPctCompletos) {
          return 'alerta-conversaciones'
        }
        return ''
      },

      cambiarEscuela (valor) {
        if (!valor || valor === this.escuela) return
        this.$router.push({ name: NOMBRE_RUTA, params: { escuela: valor } }).catch(() => {})
      },

      consultar () {
        if (!this.fechaDatos) return this.validarError('Selecciona el día de los datos')
        this.reporte = null
        this.sinReporte = false
        this.filtroSucursal = null
        this.filtroCampania = null
        this.cargar = true
        // El Analyzer corre cada mañana y guarda el JSON con la fecha de ejecución (datos del día anterior).
        // TODO Fase 2: leer de BD por rango (fechaInicio/fechaFin) y traer también el periodo anterior para comparar.
        const fechaArchivo = sumarDias(this.fechaDatos, 1)
        return this.$http.post('api/meta/analyze/report/' + this.idEscuela, { fecha: fechaArchivo })
          .then((response) => {
            this.reporte = response.data || null
          })
          .catch((error) => {
            if (error.response && error.response.status === 404) {
              this.sinReporte = true
              return
            }
            this.validarError(error)
          })
          .finally(() => { this.cargar = false })
      },
    },
  }
</script>

<style scoped>
  .alerta-gasto {
    background-color: #ffebee;
  }
  .alerta-conversaciones {
    background-color: #fff3e0;
  }
</style>
